import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import { message } from "antd";
import config from "../config";

class DistanceReportStore {
  distanceReport = [];
  total = 0;
  loading = false;
  loadingData=false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      distanceReport: observable,
      total: observable,
      loading: observable,
      loadData: action,
      exportcsv: action,
      exportExcel: action,
      exportpdf: action,
      exportxml: action,
      loadDataTotal : action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    offset,
    limit,
    vehicleId,
    fromDate,
    toDate,
    pageNo,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };

    if (config.pythonReport === 1) {
        var response = await postApi.getClient("report").post("/tracking_report/distancereport", postData);
    } else {
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
          .getClient()
          .post("index.php?c=vehicle&a=distancereport", "postData=" + base64Input);
    }

    this.distanceReport = response?.data?.data?.distanceReport;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async loadDataTotal({
    companyId,
    vehicleId,
    fromDate,
    toDate,
    
   
  }) {
    this.loadingData = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      total: true
    };

    if (config.pythonReport == 1) {

      var response = await postApi.getClient("report").post("/tracking_report/distancereport", postData);
      this.totalReport = response?.data?.data?.distanceReport;

    }else{
      
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=distanceTotal", "postData=" + base64Input);

      this.totalReport = response?.data?.data;

    }
    
    this.loadingData = false;

  }

  async exportExcel(getData) {

    if (config.pythonReport === 1) {
      

      try {

          await postApi.getClient("report").post("/tracking_report/distanceReport/download/excel", getData, {
            responseType: "blob",
          });
          this.pythonReportMessage = true;
        // var response = await postApi
        //   .getClient("report")
        //   .post("/tracking_report/distanceReport/download/excel", getData, {
        //     responseType: "blob",
        //   });

        // const blob = new Blob([response.data], {
        //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        // });

        // const link = document.createElement("a");
        // link.href = window.URL.createObjectURL(blob);
        // link.download = "Distance Report.xlsx";

        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
      } catch (error) {
          this.pythonReportErrorMessage = false;
          message.error("Failed to download the report. Please try again.");
      }
    } else {
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=vehicle&a=exportdistanceexcel&cid=" +
          getData.companyId +
          "&userId=" +
          getData.userId+
          "&vid=" +
          getData.vehicleId +
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList +
          "&language=" +
          lang;
    }
  }

  async exportcsv(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportdistancecsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId+
      "&vid=" +
      getData.vehicleId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }

  async exportpdf(getData) {

    if (config.pythonReport === 1) {
      

      try {

         await postApi.getClient("report").post("/tracking_report/distanceReport/download/pdf", getData, {
            responseType: "blob",
          });
          this.pythonReportMessage = true;
        // var response = await postApi
        //   .getClient()
        //   .post("/tracking_report/distanceReport/download/pdf", getData, {
        //     responseType: "blob",
        //   });

        // const blob = new Blob([response.data], {
        //   type: "application/pdf",
        // });

        // const link = document.createElement("a");
        // link.href = window.URL.createObjectURL(blob);
        // link.download = "Distance Report.pdf";

        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
      } catch (error) {
          this.pythonReportErrorMessage = false;
          message.error("Failed to download the report. Please try again.");
        // message.error("Failed to download the report. Please try again.");
      }
    } else {
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=vehicle&a=exportdistancepdf&cid=" +
          getData.companyId +
          "&userId=" +
          getData.userId +
          "&vid=" +
          getData.vehicleId +
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList +
          "&language=" +
          lang;
    }
  }

  async exportxml(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportdistancexml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId+
      "&vid=" +
      getData.vehicleId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
}

export default DistanceReportStore;
